import { API_ENDPOINT } from '../config';

export default function(orderId) {
    return fetch(`${API_ENDPOINT}/orders/${orderId}/pay/`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });
}
